import React, {Component} from 'react';
import Loadable from 'react-loadable';
import {Switch, Route} from 'react-router-dom';
import CodeLoading from '../components/CodeLoading';
import Login from '../../modules/auth/containers/Login';

const ForgotPassword = Loadable({loading: CodeLoading, loader: () => import("../../modules/auth/containers/ForgotPassword")});

class Narrow extends Component {
	componentDidMount() {
		ForgotPassword.preload();
	}

	render() {
		return (
			<Switch>
				<Route exact path="/auth/login" component={Login} />
				<Route exact path="/auth/forgot-password" component={ForgotPassword} />
			</Switch>
		)
	}
}

export default Narrow